export type CategoryKey =
  | 'MEMBERS'
  | 'JOIN_CODES'
  | 'INVITES'
  | 'HELPERS'
  | 'FIELD_PASSES'
  | 'PERMISSIONS'
  | 'GENERATE'

export const TAB_STORAGE_KEY = 'invites_hub_tab'

export const TM12_CATEGORIES: CategoryKey[] = [
  'MEMBERS',
  'JOIN_CODES',
  'INVITES',
  'HELPERS',
  'FIELD_PASSES',
  'PERMISSIONS',
]

export interface StoredCategoryPermissions {
  canManageInvites?: boolean
  canManageJoinCodes?: boolean
  canViewPermissions?: boolean
  canManageFieldPasses?: boolean
}

export const getTabStorageKey = (workspaceId?: string | null) =>
  workspaceId ? `invites_hub_tab_${workspaceId}` : TAB_STORAGE_KEY

export function isCategoryAllowed(
  category: CategoryKey | string,
  permissions: StoredCategoryPermissions,
): boolean {
  if (category === 'MEMBERS') return true
  if (category === 'FIELD_PASSES') return Boolean(permissions.canManageFieldPasses)
  if (category === 'JOIN_CODES') return Boolean(permissions.canManageJoinCodes)
  if (category === 'PERMISSIONS') return Boolean(permissions.canViewPermissions)
  if (category === 'INVITES' || category === 'HELPERS' || category === 'GENERATE') {
    return Boolean(permissions.canManageInvites)
  }
  return false
}

export function resolveStoredCategory(
  stored: string | null | undefined,
  permissions: StoredCategoryPermissions,
): CategoryKey {
  if (!stored) return 'MEMBERS'
  let cat: CategoryKey = 'MEMBERS'
  if (stored === 'GENERATE' || stored === 'PENDING') cat = 'INVITES'
  else if (stored === 'PERMISSIONS') {
    return permissions.canManageInvites ? 'INVITES' : 'MEMBERS'
  }
  else if (
    stored === 'MEMBERS' ||
    stored === 'JOIN_CODES' ||
    stored === 'INVITES' ||
    stored === 'HELPERS' ||
    stored === 'FIELD_PASSES'
  ) {
    cat = stored as CategoryKey
  }
  if (!isCategoryAllowed(cat, permissions)) {
    if (cat === 'JOIN_CODES' && permissions.canManageInvites) return 'INVITES'
    return 'MEMBERS'
  }
  return cat
}
